import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import EInk from '../../models/EInk';
import RenderUser from '../RenderUser';

interface EInkItemProps {
   eink: EInk;
};

const EInkItem: React.FC<EInkItemProps> = (props: EInkItemProps) => {
   return(
      <Link to={`/eink/${props.eink.id}`} className="d-block w-100" >
         <div className="card mb-3">
            <div className="card-body screen-item">
               <div className="screen-item__name">
                  <i className="iconsminds-monitor"></i>
                  <span className="ml-2">{ props.eink.name }</span>
               </div>
               <div className="screen-item__actions">
                  <RenderUser
                     item={props.eink}
                  />
                  <span className="screen-item__detail-link">
                     <FontAwesomeIcon icon={faChevronRight} />
                  </span>
               </div>
            </div>
         </div>
      </Link>
   );
}

export default React.memo(EInkItem);
